import React, { useEffect } from 'react';
import SignalsPresentational from './SignalsPresentational';
import './MySignals.scss';
import { useAuth } from '../../../commons/Auth';

const SignalsAdminRentalsSales = ({
  profile,
  query,
  total,
  signals,
  signalTypes,
  onFilter,
  onUpdateSignal,
  searchSignalmens,
  searchCondos,
  searchAdmins,
  handleFileListView,
  deleteFileConfirm,
}) => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();

  return (
    <SignalsPresentational
      data={signals}
      signalTypes={signalTypes}
      profile={profile}
      newIsAdmin={newIsAdmin}
      query={query}
      total={total}
      onFilter={onFilter}
      onUpdateSignal={onUpdateSignal}
      searchSignalmens={searchSignalmens}
      searchCondos={searchCondos}
      searchAdmins={searchAdmins}
      handleFileListView={handleFileListView}
      deleteFileConfirm={deleteFileConfirm}
    />
  );
};

export default SignalsAdminRentalsSales;
